import DownloadControl from './DownloadControl';
import FileThumbnail from './FileThumbnail';
import PermissionDots from './PermissionDots';
import SelectionCheckbox from './SelectionCheckbox';
import type { FileItemViewModel } from './types';

interface FileListItemProps {
  id: string;
  file: any;
  roles: Array<number>;
  selected: boolean;
  groupColours: Array<any>;
  showDownloadMenu: boolean;
  downloadingSize: string;
  loadingCropTool: boolean;
  viewModel: FileItemViewModel;
  selectItem: (id: number) => void;
  downloadFile: (id: number, filename: string, size: string) => void;
  openCropTool: (id: number) => void;
  toggleActiveDownloadMenu: (id: string) => void;
}

const FileListItem = ({
  id,
  file,
  roles,
  selected,
  groupColours,
  showDownloadMenu,
  downloadingSize,
  loadingCropTool,
  viewModel,
  selectItem,
  downloadFile,
  openCropTool,
  toggleActiveDownloadMenu,
}: FileListItemProps) => (
  <div className="flex w-full py-3 border-t border-suzy-gray ">
    {(roles.includes(0) || roles.includes(1)) && (
      <div className="w-[50px] grid content-center flex-shrink-0">
        <SelectionCheckbox
          selected={selected}
          onClick={() => selectItem(file.ID)}
          className="grid p-0.5 content-center inline-block w-5 h-5 mr-5 border rounded cursor-pointer"
        />
      </div>
    )}
    <div className="grid content-center w-[60px] flex-shrink-0">
      <div className="relative w-8 h-8 overflow-hidden rounded">
        <FileThumbnail
          file={file}
          mimeType={viewModel.mimeType}
          placeholder={viewModel.placeholder}
          isSvgOrAi={viewModel.isSvgOrAi}
          imageClassName="w-full h-full absolute top-0 left-0"
          placeholderClassName="w-full h-full object-scale-down absolute top-0 left-0'"
        />
      </div>
    </div>
    <div className="grid content-center px-6 flex-grow min-w-[100px]">
      <p
        title={file.file}
        className="relative m-0 overflow-hidden text-xs md:text-sm filename-ellipsis"
      >
        {file.file}
      </p>
    </div>
    <div className="w-[150px] px-6 grid content-center flex-shrink-0">
      {(roles.includes(0) || roles.includes(1)) && (
        <div className="relative flex content-center justify-start gap-1">
          <PermissionDots
            groupColours={groupColours}
            tooltipClassName="hidden group-hover/groups:block absolute bottom-4 px-2 py-0.5 rounded bg-white text-xs left-1/2 shadow -translate-x-2/4"
          />
        </div>
      )}
    </div>
    <div className="px-6 w-[150px] grid content-center flex-shrink-0">
      <p className="relative m-0 text-xs text-gray-400 md:text-sm">
        {viewModel.readableDate}
      </p>
    </div>
    <div className="px-6 w-[120px] grid content-center flex-shrink-0">
      <p className="relative m-0 text-xs text-gray-400 md:text-sm">
        {viewModel.formattedSize}
      </p>
    </div>
    <div className="px-6 w-[160px] grid content-center relative flex-shrink-0">
      <DownloadControl
        id={id}
        file={file}
        dimensions={viewModel.dimensions}
        isImage={viewModel.isImage}
        showDownloadMenu={showDownloadMenu}
        downloadingSize={downloadingSize}
        loadingCropTool={loadingCropTool}
        menuClassName="absolute z-20 top-0 w-[150px] border border-gray-100 shadow py-1 bg-white rounded right-[100%]"
        iconClassName="p-[3px] stroke-gray-400 hover:stroke-default transition-color download-button h-6 w-6 inline-block transition-colors bg-opacity-50 cursor-pointer"
        iconWrapperClassName="flex items-start gap-2 cursor-pointer group"
        downloadFile={downloadFile}
        openCropTool={openCropTool}
        toggleActiveDownloadMenu={toggleActiveDownloadMenu}
      />
    </div>
  </div>
);

export default FileListItem;
